export interface Todo {
  id: string;
  title: string;
  description: string;
  dueDate: string;
  status: string;
  priority: string;
  createdDate: string;
}

export enum Priority {
  Low = 0,
  Medium = 1,
  High = 2,
}

export enum ReminderType {
  Once = 0,
  Repeat = 1,
}

export enum RepeatInterval {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
}

export interface AddTodoRequest {
  title: string;
  description: string;
  dueDate: string;
  priority: Priority;
  assignees: { assignToId: string }[];
  reminder: {
    reminderDateTime: string;
    reminderType: ReminderType;
    repeatInterval: RepeatInterval;
  };
}

export interface UpdateTodoRequest extends AddTodoRequest {}

export interface TodoResponse {
  id: string;
  title: string;
  description: string;
  dueDate: string;
  status: string;
  priority: Priority;
  createdDate: string;
  assignees: {
    assignToId: string;
    assignToName?: string;
  }[];
  reminder: {
    reminderDateTime: string;
    reminderType: ReminderType;
    repeatInterval: RepeatInterval;
  };
}

/* REAL-TIME REMINDER MODEL */
export interface TodoReminder {
  id: string;
  title: string;
  description: string;
  dueDate: string;
  priority: number;
}

export interface iEmployeeResultDto {
  id: string;
  firstName: string;
  lastName: string;
  name?: string;
  type?: string;
  Type?: string;
  profilePic?: string;
  reportsToProfile?: string;
}
